export const triggerBingAnalytics = (url: string) => {
  fetch(url, {
    method: 'GET'
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      console.error(error);
    });
};
